/**
 * #modmail.ts
 *
 * Code generated by ts-proto. DO NOT EDIT.
 * @packageDocumentation
 */
/* eslint-disable */
import _m0 from "protobufjs/minimal.js";
import { Timestamp } from "../../../google/protobuf/timestamp.js";
import { messageTypeRegistry } from "../../../typeRegistry.js";
import { SubredditV2 } from "./subredditv2.js";
import { UserV2 } from "./userv2.js";
function createBaseModMail() {
    return {
        messageAuthor: undefined,
        createdAt: undefined,
        messageAuthorType: "",
        conversationState: "",
        conversationType: "",
        isAutoGenerated: false,
        conversationSubreddit: undefined,
        destinationSubreddit: undefined,
        conversationId: "",
        messageId: "",
    };
}
export const ModMail = {
    $type: "devvit.reddit.v2alpha.ModMail",
    encode(message, writer = _m0.Writer.create()) {
        if (message.messageAuthor !== undefined) {
            UserV2.encode(message.messageAuthor, writer.uint32(10).fork()).ldelim();
        }
        if (message.createdAt !== undefined) {
            Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(18).fork()).ldelim();
        }
        if (message.messageAuthorType !== "") {
            writer.uint32(34).string(message.messageAuthorType);
        }
        if (message.conversationState !== "") {
            writer.uint32(50).string(message.conversationState);
        }
        if (message.conversationType !== "") {
            writer.uint32(58).string(message.conversationType);
        }
        if (message.isAutoGenerated !== false) {
            writer.uint32(64).bool(message.isAutoGenerated);
        }
        if (message.conversationSubreddit !== undefined) {
            SubredditV2.encode(message.conversationSubreddit, writer.uint32(74).fork()).ldelim();
        }
        if (message.destinationSubreddit !== undefined) {
            SubredditV2.encode(message.destinationSubreddit, writer.uint32(98).fork()).ldelim();
        }
        if (message.conversationId !== "") {
            writer.uint32(82).string(message.conversationId);
        }
        if (message.messageId !== "") {
            writer.uint32(90).string(message.messageId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseModMail();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.messageAuthor = UserV2.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.messageAuthorType = reader.string();
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.conversationState = reader.string();
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.conversationType = reader.string();
                    continue;
                case 8:
                    if (tag !== 64) {
                        break;
                    }
                    message.isAutoGenerated = reader.bool();
                    continue;
                case 9:
                    if (tag !== 74) {
                        break;
                    }
                    message.conversationSubreddit = SubredditV2.decode(reader, reader.uint32());
                    continue;
                case 12:
                    if (tag !== 98) {
                        break;
                    }
                    message.destinationSubreddit = SubredditV2.decode(reader, reader.uint32());
                    continue;
                case 10:
                    if (tag !== 82) {
                        break;
                    }
                    message.conversationId = reader.string();
                    continue;
                case 11:
                    if (tag !== 90) {
                        break;
                    }
                    message.messageId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            messageAuthor: isSet(object.messageAuthor) ? UserV2.fromJSON(object.messageAuthor) : undefined,
            createdAt: isSet(object.createdAt) ? fromJsonTimestamp(object.createdAt) : undefined,
            messageAuthorType: isSet(object.messageAuthorType) ? globalThis.String(object.messageAuthorType) : "",
            conversationState: isSet(object.conversationState) ? globalThis.String(object.conversationState) : "",
            conversationType: isSet(object.conversationType) ? globalThis.String(object.conversationType) : "",
            isAutoGenerated: isSet(object.isAutoGenerated) ? globalThis.Boolean(object.isAutoGenerated) : false,
            conversationSubreddit: isSet(object.conversationSubreddit)
                ? SubredditV2.fromJSON(object.conversationSubreddit)
                : undefined,
            destinationSubreddit: isSet(object.destinationSubreddit)
                ? SubredditV2.fromJSON(object.destinationSubreddit)
                : undefined,
            conversationId: isSet(object.conversationId) ? globalThis.String(object.conversationId) : "",
            messageId: isSet(object.messageId) ? globalThis.String(object.messageId) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.messageAuthor !== undefined) {
            obj.messageAuthor = UserV2.toJSON(message.messageAuthor);
        }
        if (message.createdAt !== undefined) {
            obj.createdAt = message.createdAt.toISOString();
        }
        if (message.messageAuthorType !== "") {
            obj.messageAuthorType = message.messageAuthorType;
        }
        if (message.conversationState !== "") {
            obj.conversationState = message.conversationState;
        }
        if (message.conversationType !== "") {
            obj.conversationType = message.conversationType;
        }
        if (message.isAutoGenerated !== false) {
            obj.isAutoGenerated = message.isAutoGenerated;
        }
        if (message.conversationSubreddit !== undefined) {
            obj.conversationSubreddit = SubredditV2.toJSON(message.conversationSubreddit);
        }
        if (message.destinationSubreddit !== undefined) {
            obj.destinationSubreddit = SubredditV2.toJSON(message.destinationSubreddit);
        }
        if (message.conversationId !== "") {
            obj.conversationId = message.conversationId;
        }
        if (message.messageId !== "") {
            obj.messageId = message.messageId;
        }
        return obj;
    },
    create(base) {
        return ModMail.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseModMail();
        message.messageAuthor = (object.messageAuthor !== undefined && object.messageAuthor !== null)
            ? UserV2.fromPartial(object.messageAuthor)
            : undefined;
        message.createdAt = object.createdAt ?? undefined;
        message.messageAuthorType = object.messageAuthorType ?? "";
        message.conversationState = object.conversationState ?? "";
        message.conversationType = object.conversationType ?? "";
        message.isAutoGenerated = object.isAutoGenerated ?? false;
        message.conversationSubreddit =
            (object.conversationSubreddit !== undefined && object.conversationSubreddit !== null)
                ? SubredditV2.fromPartial(object.conversationSubreddit)
                : undefined;
        message.destinationSubreddit = (object.destinationSubreddit !== undefined && object.destinationSubreddit !== null)
            ? SubredditV2.fromPartial(object.destinationSubreddit)
            : undefined;
        message.conversationId = object.conversationId ?? "";
        message.messageId = object.messageId ?? "";
        return message;
    },
};
messageTypeRegistry.set(ModMail.$type, ModMail);
function toTimestamp(date) {
    const seconds = Math.trunc(date.getTime() / 1000);
    const nanos = (date.getTime() % 1000) * 1000000;
    return { seconds, nanos };
}
function fromTimestamp(t) {
    let millis = (t.seconds || 0) * 1000;
    millis += (t.nanos || 0) / 1000000;
    return new globalThis.Date(millis);
}
function fromJsonTimestamp(o) {
    if (o instanceof globalThis.Date) {
        return o;
    }
    else if (typeof o === "string") {
        return new globalThis.Date(o);
    }
    else {
        return fromTimestamp(Timestamp.fromJSON(o));
    }
}
function isSet(value) {
    return value !== null && value !== undefined;
}
